import { getRefreshTokenCookie } from "lib/Storage";

const navigationEnum = {
  AUTHENTICATION: {
    path: "/national-id",
    name: "احراز هویت",
  },
  ACCOUNT: {
    path: "/edit-account",
    name: "حساب کاربری",
  },
  EDIT_ACCOUNT: {
    path: "/edit-account",
    name: "حساب کاربری",
  },
  SECURITY: {
    path: "/security",
    name: "امنیت و حریم خصوصی",
  },
  ON_CARD: {
    path: "/on-card",
    name: "آن کارت",
  },
  PRIVILEGES: {
    path: "/privileges",
    name: "امتیازات",
  },
  INVITE_FRIENDS: {
    path: "/invite-friends",
    name: "دعوت از دوستان",
  },
  ACCPECTING_RULES: {
    path: "/accpecting-rules",
    name: "پذیرش قوانین",
  },
  REGISTER_CONCERT: {
    path: "/register-concert",
    name: "ثبت نام در کنسرت",
  },
  TL_TIMELINE: {
    path: `https://app.tltimeline.ir/?t=${getRefreshTokenCookie()}`,
    name: "TL",
  },
  REGISTERGUIDE: {
    path: `https://fs.zharfabeen.com/academypublic/%D8%B1%D8%A7%D9%87%D9%86%D9%85%D8%A7%DB%8C%20%D8%B4%D8%B1%DA%A9%D8%AA%20%D8%AF%D8%B1%20%DA%A9%D9%86%D8%B3%D8%B1%D8%AA.pdf`,
    name: "راهنما"
  },
  CALL_SUPPORT:{
    path: "tel:09981209489",
    name: "تماس با پشتیبانی",
  },
  LOGOUT: {
    path: "/login",
    name: "خروج از حساب کاربری",
  },
};

export default navigationEnum;
